// extracted by mini-css-extract-plugin
export default {"cls1":"BRuBU9vQOBAeWjVoug3H","cls2":"EnjF4bI605idrj2qW_r1 BRuBU9vQOBAeWjVoug3H"};